<template>
  <!--
      作者：wangxw
      时间：2020-06-10
      描述：页面-页面列表-添加页面
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" :rules="rules" label-width="200px">

      <div class="common-form">基本信息</div>
      <el-form-item label="风格名称" prop="name">
        <el-input v-model="form.name" class="max-w460"></el-input>
      </el-form-item>

      <div class="common-form">标题风格</div>
      <el-form-item label="标题字体颜色" prop="content.titleTextColor">
        <el-radio v-model="form.content.titleTextColor" label="black">黑色</el-radio>
        <el-radio v-model="form.content.titleTextColor" label="white">白色</el-radio>
      </el-form-item>
      <el-form-item label="主体色调" prop="content.titleBackgroundColor">
        <!--<el-input v-model="form.titleBackgroundColor" class="max-w460"></el-input>-->
        <div class="d-s-c">
          <el-color-picker v-model="form.content.titleBackgroundColor"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
            重置
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="字体反色">
        <el-switch v-model="form.content.isReverseColor" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
      </el-form-item>


      <div class="common-form">预设按钮</div>


<div style="display: flex;width: 80%;">
  <el-form-item label="字体一颜色" style="flex:0.5;" prop="content.button.oneFontColor">
  <div class="d-s-c">
  <el-color-picker v-model="form.content.button.oneFontColor"></el-color-picker>
    <el-button type="button" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
      重置
    </el-button>
    </div>
</el-form-item>

<el-form-item label="按钮一背景" style="flex:0.5;" prop="content.button.oneColor">
  <!--<el-input v-model="form.titleBackgroundColor" class="max-w460"></el-input>-->
  <div class="d-s-c">
    <el-color-picker v-model="form.content.button.oneColor"></el-color-picker>
    <el-button type="button" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
      重置
    </el-button>
  </div>
</el-form-item>


<el-form-item label="预览" style="flex:0.5;">

  <div class="d-s-c">
 
    <el-button type="button" :style="{color:form.content.button.oneFontColor,background:form.content.button.oneColor}" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
      测试按钮
    </el-button>
  </div>
</el-form-item>

<el-form-item label="" style="flex:1;"><div class="d-s-c"></div></el-form-item>

</div>


    <div style="display: flex;width: 80%;">
      <el-form-item label="字体二颜色" style="flex:0.5;" prop="content.button.twoFontColor">
      <div class="d-s-c">
      <el-color-picker v-model="form.content.button.twoFontColor"></el-color-picker>
        <el-button type="button" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
          重置
        </el-button>
        </div>
    </el-form-item>

    <el-form-item label="按钮二背景" style="flex:0.5;" prop="content.button.twoColor">
      <!--<el-input v-model="form.titleBackgroundColor" class="max-w460"></el-input>-->
      <div class="d-s-c">
        <el-color-picker v-model="form.content.button.twoColor"></el-color-picker>
        <el-button type="button" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
          重置
        </el-button>
      </div>
    </el-form-item>


    <el-form-item label="预览" style="flex:0.5;">

      <div class="d-s-c">
    
        <el-button type="button" :style="{color:form.content.button.twoFontColor,background:form.content.button.twoColor}" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
          测试按钮
        </el-button>
      </div>
    </el-form-item>

    <el-form-item label="" style="flex:1;"><div class="d-s-c"></div></el-form-item>

    </div>


    <div style="display: flex;width: 80%;">
      <el-form-item label="字体三颜色" style="flex:0.5;" prop="content.button.threeFontColor">
      <div class="d-s-c">
      <el-color-picker v-model="form.content.button.threeFontColor"></el-color-picker>
        <el-button type="button" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
          重置
        </el-button>
        </div>
    </el-form-item>

    <el-form-item label="按钮三背景" style="flex:0.5;" prop="content.button.threeColor">
      <div class="d-s-c">
        <el-color-picker v-model="form.content.button.threeColor"></el-color-picker>
        <el-button type="button" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
          重置
        </el-button>
      </div>
    </el-form-item>


    <el-form-item label="预览" style="flex:0.5;">

      <div class="d-s-c">
    
        <el-button type="button" :style="{color:form.content.button.threeFontColor,background:form.content.button.threeColor}" style="margin-left: 10px;" @click.stop="onEditorResetColor()">
          测试按钮
        </el-button>
      </div>
    </el-form-item>

    <el-form-item label="" style="flex:1;"><div class="d-s-c"></div></el-form-item>

    </div>



      <!--提交-->
      <div class="common-button-wrapper"><el-button type="primary" @click="Submit" :loading="loading">提交</el-button></div>
    </el-form>
  </div>
</template>

<script>
import {deepClone} from '@/utils/base.js'
import PageApi from '@/api/page.js';
export default {
  components: {},
  data() {
    return {
      /*是否正在加载*/
      loading: false,
      /*表单对象*/
      form: {
        name: '',
        content: {
          /* 标题背景色 */
          titleBackgroundColor: '',
          /* 标题字体颜色 */
          titleTextColor: '',
            bgColorOne:"",
          bgColorTwo:"",
          /*字体颜色是否为主色调的反色*/
          isReverseColor: false,
           // 预设按钮一颜色
           oneColor:"",
              //预设按钮字体一颜色
              oneFontColor:"",
              // 预设按钮二颜色
              twoColor:"",
              //预设按钮字体二颜色
              twoFontColor:"",
              // 预设按钮三颜色
              threeColor:"",
              //预设按钮字体三颜色
              threeFontColor:"",
        },
      },
      rules: {
        name: [
          {required: true, message: '请输入风格名称', trigger: 'blur'},
        ],
        'content.titleBackgroundColor': [
          {required: true, message: '请选择背景颜色', trigger: 'blur'},
        ],
        'content.titleTextColor': [
          {required: true, message: '请选择字体颜色', trigger: 'blur'},
        ],
        'content.button.oneColor': [
          {required: true, message: '请选择预设按钮一颜色', trigger: 'blur'},
        ],
        'content.button.twoColor': [
          {required: true, message: '请选择预设按钮二颜色', trigger: 'blur'},
        ],
        'content.button.threeColor': [
          {required: true, message: '请选择预设按钮三颜色', trigger: 'blur'},
        ],
        'content.button.oneFontColor': [
          {required: true, message: '请选择预设按钮字体一颜色', trigger: 'blur'},
        ],
        'content.button.oneFontColor': [
          {required: true, message: '请选择预设按钮字体二颜色', trigger: 'blur'},
        ],
        'content.button.oneFontColor': [
          {required: true, message: '请选择预设按钮字体三颜色', trigger: 'blur'},
        ],
      }
    };
  },
  created() {},
  methods: {

    /*添加页面*/
    Submit() {
      let self = this
      self.loading = true;
      // 表单验证
      this.$refs['form'].validate((valid) => {
        if (valid) {
          PageApi.saveStyle(
            {
              style: self.form
            },true
          ).then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，添加成功',
              type: 'success'
            });
            self.gotoBack();
          }).catch(error => {
            self.loading = false;
          }).finally (res => {
            self.loading = false;
          })
        } else {
          console.log('error submit!!');
          self.loading = false;
          return false;
        }
      })
    },

    /*返回上一页面*/
    gotoBack(){
      this.$router.back(-1);
    },

    onEditorResetColor() {
      this.form.titleBackgroundColor = ''
    }

  }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/page/style/add.vue